var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-notification',{staticClass:"bg-rose-50 border-rose-300 text-rose-900",attrs:{"message":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }